/**
 * Firebase Configuration
 * 
 * This file contains the Firebase configuration for the Congroup website.
 * Replace the placeholder values with your actual Firebase project credentials.
 * 
 * To set up Firebase:
 * 1. Create a project at https://console.firebase.google.com/
 * 2. Enable Authentication (Email/Password provider)
 * 3. Enable Firestore Database
 * 4. Enable Storage
 * 5. Add a web app to get your configuration object
 */

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDrqXGfD8mAwe9c3zDdtgQTcOhlBmmK6Pw',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'congroup-f8b5c.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'congroup-f8b5c',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'congroup-f8b5c.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '871340799737',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:871340799737:web:bbdd5cb5b942449c1f5428',
};

// Environment variables required:
// VITE_FIREBASE_API_KEY - Firebase API key
// VITE_FIREBASE_AUTH_DOMAIN - Firebase auth domain (project-id.firebaseapp.com)
// VITE_FIREBASE_PROJECT_ID - Firebase project ID
// VITE_FIREBASE_STORAGE_BUCKET - Firebase storage bucket (project-id.appspot.com)
// VITE_FIREBASE_MESSAGING_SENDER_ID - Firebase messaging sender ID
// VITE_FIREBASE_APP_ID - Firebase app ID